/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export const SET_SCREEN_CONTROLLER = 'SET_SCREEN_CONTROLLER';
export const SET_SCREEN_TASK_CONTROLLER = 'SET_SCREEN_TASK_CONTROLLER';
